import React, {FC} from "react";
import {useSelector} from "react-redux";
import {IRootState} from "../../store/configureStore";
import {ProgressBarBody, ProgressBarContainer, ProgressBarText} from "./ProgressBarStyle";
import {ProgressBar} from "react-bootstrap";


const ProgressBarView: FC = () => {
    const {bar, progressBar} = useSelector((state: IRootState) => state.app)

    return (
        <ProgressBarContainer loading={bar}>
            <ProgressBarBody>
                <ProgressBar now={progressBar} animated style={{width: "100%"}}/>
                {progressBar < 100 && <ProgressBarText>Загрузка...</ProgressBarText>}
                {progressBar >= 100 && <ProgressBarText>Сохранение...</ProgressBarText>}
            </ProgressBarBody>
        </ProgressBarContainer>
    )
}
export default ProgressBarView
